import React from "react";
import {
    useDisclosure,
    useBreakpointValue,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverArrow,
    PopoverCloseButton,
    PopoverHeader,
    PopoverBody,
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerHeader,
    DrawerCloseButton,
    DrawerBody, Flex,
} from "@chakra-ui/react";

interface ResponsivePopoverDrawerProps {
    trigger: React.ReactNode;
    header?: React.ReactNode;
    children: React.ReactNode;
}

const ResponsivePopoverDrawer: React.FC<ResponsivePopoverDrawerProps> = ({
                                                                             trigger,
                                                                             header,
                                                                             children,
                                                                         }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const isMobile = useBreakpointValue({ base: true, lg: false });

    if (isMobile) {
        return (
            <>
                <Flex w={"100%"} onClick={onOpen}>{trigger}</Flex>
                <Drawer isOpen={isOpen} onClose={onClose} placement="top">
                    <DrawerOverlay />
                    <DrawerContent>
                        <DrawerCloseButton />
                        {header && <DrawerHeader>{header}</DrawerHeader>}
                        <DrawerBody>{children}</DrawerBody>
                    </DrawerContent>
                </Drawer>
            </>
        );
    }

    return (
        <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement="auto">
            <PopoverTrigger>
                <span onClick={onOpen}>{trigger}</span>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow />
                <PopoverCloseButton />
                {header && <PopoverHeader>{header}</PopoverHeader>}
                <PopoverBody>{children}</PopoverBody>
            </PopoverContent>
        </Popover>
    );
};

export default ResponsivePopoverDrawer;
